import { render, staticRenderFns } from "./poundList.vue?vue&type=template&id=010bc4c6"
import script from "./poundList.vue?vue&type=script&lang=js"
export * from "./poundList.vue?vue&type=script&lang=js"
import style0 from "./poundList.vue?vue&type=style&index=0&id=010bc4c6&prod&lang=stylus"
import style1 from "./poundList.vue?vue&type=style&index=1&id=010bc4c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports